import React, {Component} from "react";
import {connect} from "react-redux";

import {ConfigurationsActionCreators} from "../../../../actions/actionCreators";
import {ConfigurationsActionTypes} from "../../../../actions/actionTypes";
import {RTPProfilesOrder} from "../../../../reducers/rtpProfiles.reducer";
import {configurationsStoreSelectors} from "../../../../store/store";
import {
    areAllSelectedGamesAssignedRTPProfile,
    isRTPProfileGameSelected
} from "../../../Utils/rtp-profiles";
import SoundsPagination from "../SoundsConfigurationSection/SoundsPagination/SoundsPagination.component";
import RTPProfilesFilterHeader from "./RTPProfilesFilterHeader.component";
import RTPProfilesTable from "./RTPProfilesTable.component";

import "./RTPProfileConfigurationSection.component.scss";

const GAME_TYPES = {
    0: "Bingo",
    1: "Spins",
    2: "Lotto",
    3: "Keno"
};

export interface RTPProfilesFilterSelected {
    selectedProfile: string | number;
    selectedGames: string[];
}

interface RTPProfileConfigurationSectionProps {
    editingConfiguration: any;
    defaultProfile: any;
    previousDefaultProfile: number | null;
    profiles: any[];
    settings: any[];
    order: RTPProfilesOrder;
    loading: boolean;
    selectedGameInstances: any[];
    setRTPProfilesOrder: any;
    updateRTPProfile: any;
    updateRTPProfilesConfig: any;
    configSectionVisited: any;
}

interface RTPProfileConfigurationSectionState {
    currentPage: number;
    rowsPerPage: number;
    selectedFilters: RTPProfilesFilterSelected;
}

export class RTPProfileConfigurationSection extends Component<
    RTPProfileConfigurationSectionProps,
    RTPProfileConfigurationSectionState
> {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            rowsPerPage: 15,
            selectedFilters: {
                selectedProfile: -1,
                selectedGames: []
            }
        };
    }

    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_RTP_PROFILES_CONFIG
        );
        this.updateValidity(this.props);
    }

    componentDidUpdate(previousProps) {
        const previousGameTypes = this.getSelectedGameTypes(previousProps);
        const currentGameTypes = this.getSelectedGameTypes(this.props);
        const selectedGameTypesChanged =
            previousGameTypes.length !== currentGameTypes.length ||
            previousGameTypes.some(
                (gameType, index) => gameType !== currentGameTypes[index]
            );

        if (
            selectedGameTypesChanged ||
            previousProps.editingConfiguration.settings.selectedGroupType !==
                this.props.editingConfiguration.settings.selectedGroupType ||
            previousProps.settings !== this.props.settings ||
            previousProps.selectedGameInstances !==
                this.props.selectedGameInstances
        ) {
            this.updateValidity(this.props);
        }
    }

    getSelectedGameTypes = props => {
        const editingConfiguration = props && props.editingConfiguration;
        const configurationSettings =
            editingConfiguration &&
            editingConfiguration.settings &&
            editingConfiguration.settings.settings;
        const settings =
            configurationSettings && configurationSettings.settings;

        return settings ? settings.game_types || [] : [];
    };

    updateValidity = props => {
        this.props.updateRTPProfilesConfig({
            isValid: areAllSelectedGamesAssignedRTPProfile(
                props.settings,
                props.selectedGameInstances,
                this.getSelectedGameTypes(props),
                props.editingConfiguration.settings.selectedGroupType
            )
        });
    };

    updateFilters = selectedFilters => {
        this.setState({
            selectedFilters,
            currentPage: 0
        });
    };

    getGroupSelectedSettings = () => {
        return this.props.settings.filter(setting =>
            isRTPProfileGameSelected(
                setting,
                this.props.selectedGameInstances,
                this.props.editingConfiguration.settings.selectedGroupType
            )
        );
    };

    getSettingsWithFilters = () => {
        const selectedGameTypes = this.getSelectedGameTypes(this.props);
        let settings = this.getGroupSelectedSettings().filter(setting =>
            selectedGameTypes.includes(GAME_TYPES[setting.game.type])
        );

        if (this.state.selectedFilters.selectedGames.length > 0) {
            settings = settings.filter(setting =>
                this.state.selectedFilters.selectedGames.includes(
                    setting.description
                )
            );
        }

        if (this.state.selectedFilters.selectedProfile !== -1) {
            settings = settings.filter(
                setting =>
                    setting.profile ===
                    this.state.selectedFilters.selectedProfile
            );
        }

        return settings;
    };

    goToPage = currentPage => this.setState({currentPage});

    nextPage = () => {
        const pages = Math.ceil(
            this.getSettingsWithFilters().length / this.state.rowsPerPage
        );
        if (this.state.currentPage < pages - 1) {
            this.setState({currentPage: this.state.currentPage + 1});
        }
    };

    previousPage = () => {
        if (this.state.currentPage > 0) {
            this.setState({currentPage: this.state.currentPage - 1});
        }
    };

    reorderProfiles = (key, direction) => {
        this.props.setRTPProfilesOrder({
            settings: this.props.settings,
            order: {key, direction}
        });
    };

    render() {
        const selectedGameTypes = this.getSelectedGameTypes(this.props);

        if (selectedGameTypes.length === 0) {
            return (
                <div id="RTPProfileConfigurationSection">
                    <div className="row">
                        <div className="empty-prize-types">
                            <p>
                                <i className="icon-exclamation-circle-light" />
                                A game type must be selected in General Settings
                                to configure RTP Profiles.
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        const settings = this.getSettingsWithFilters();
        const pages = Math.ceil(settings.length / this.state.rowsPerPage);
        const currentPage =
            pages <= this.state.currentPage ? 0 : this.state.currentPage;
        const start = currentPage * this.state.rowsPerPage;
        const end = Math.min(start + this.state.rowsPerPage, settings.length);
        const pageRows = settings.slice(start, end);

        return (
            <div id="RTPProfileConfigurationSection">
                <div className="row">
                    <div className="filters-panel open">
                        <RTPProfilesFilterHeader
                            defaultProfile={this.props.defaultProfile}
                            previousDefaultProfile={
                                this.props.previousDefaultProfile
                            }
                            profiles={this.props.profiles}
                            settings={this.getGroupSelectedSettings()}
                            selectedFilters={this.state.selectedFilters}
                            updateFilters={this.updateFilters}
                        />
                    </div>
                </div>
                <div className="row">
                    <div id="rtp-profiles-container">
                        {pageRows.length > 0 && (
                            <RTPProfilesTable
                                defaultProfile={this.props.defaultProfile}
                                rows={pageRows}
                                profiles={this.props.profiles}
                                currentOrder={this.props.order}
                                reorderAction={this.reorderProfiles}
                                changeProfile={(gameIdentifier, profile) =>
                                    this.props.updateRTPProfile({
                                        gameIdentifier,
                                        profile
                                    })
                                }
                            />
                        )}
                        {!this.props.loading && pageRows.length === 0 && (
                            <div className="not-found">
                                No RTP Profiles Found.
                            </div>
                        )}
                        <SoundsPagination
                            rows={pageRows}
                            start={settings.length > 0 ? start + 1 : 0}
                            end={end}
                            pages={pages}
                            currentPage={currentPage}
                            total={settings.length}
                            navigationAction={this.goToPage}
                            nextAction={this.nextPage}
                            previousAction={this.previousPage}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    editingConfiguration: configurationsStoreSelectors.editingConfiguration(
        state
    ),
    defaultProfile: configurationsStoreSelectors.rtpDefaultProfile(state),
    previousDefaultProfile:
        configurationsStoreSelectors.previousRTPDefaultProfile(state),
    profiles: configurationsStoreSelectors.rtpProfiles(state),
    settings: configurationsStoreSelectors.rtpProfileSettings(state),
    order: configurationsStoreSelectors.rtpProfilesOrder(state),
    loading: configurationsStoreSelectors.rtpProfilesLoading(state),
    selectedGameInstances:
        configurationsStoreSelectors.selectedGameInstances(state)
});

const mapDispatchToProps = {
    setRTPProfilesOrder: ConfigurationsActionCreators.setRTPProfilesOrder,
    updateRTPProfile: ConfigurationsActionCreators.updateRTPProfile,
    updateRTPProfilesConfig:
        ConfigurationsActionCreators.updateRTPProfilesConfig,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RTPProfileConfigurationSection);
